var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 2.375H15.8346V0.79043C15.8346 0.352539 15.4783 0 15.0441 0H14.25C13.8121 0 13.4596 0.35625 13.4596 0.79043V2.375H5.54043V0.79043C5.54043 0.35625 5.18789 0 4.75 0H3.95957C3.52168 0 3.16543 0.35625 3.16543 0.79043V2.375H2.375C1.06504 2.375 0 3.44004 0 4.75V16.625C0 17.935 1.06504 19 2.375 19H16.625C17.935 19 19 17.935 19 16.625V4.75C19 3.44004 17.935 2.375 16.625 2.375ZM15.0553 8.40156L8.75781 14.6953C8.55371 14.9031 8.27168 15.0145 7.98223 15.0145C7.95625 15.0145 7.92656 15.0145 7.89687 15.0107C7.57773 14.9848 7.28828 14.8252 7.09902 14.5654L4.08945 10.4648C3.7332 9.97871 3.83711 9.29219 4.32324 8.93594C4.80937 8.57969 5.4959 8.68359 5.85215 9.16973L8.1084 12.2461L13.5004 6.8541C13.9271 6.42734 14.6211 6.42734 15.0479 6.8541C15.482 7.28086 15.482 7.97109 15.0553 8.40156Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToday);
export default __webpack_public_path__ + "static/media/today.b7654418.svg";
export { ForwardRef as ReactComponent };